// extracted by mini-css-extract-plugin
export default {"container":"styles_container__S4QY9","title":"styles_title__2sm9n","form":"styles_form__dDo2Z","alert":"styles_alert__Pvpae","invalidPassword":"styles_invalidPassword__mkjqv"};